import { render, staticRenderFns } from "./ModalBox.vue?vue&type=template&id=76940a85&scoped=true"
import script from "./ModalBox.vue?vue&type=script&lang=js"
export * from "./ModalBox.vue?vue&type=script&lang=js"
import style0 from "./ModalBox.vue?vue&type=style&index=0&id=76940a85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76940a85",
  null
  
)

export default component.exports